/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMehrarbeitAuszahlungDto } from '../../models/create-mehrarbeit-auszahlung-dto';
import { MehrarbeitAuszahlungDto } from '../../models/mehrarbeit-auszahlung-dto';

export interface CreateMehrarbeitAuszahlung$Plain$Params {
  
    /**
     * Daten der Mehrarbeit Auszahlung
     */
    body?: CreateMehrarbeitAuszahlungDto
}

export function createMehrarbeitAuszahlung$Plain(http: HttpClient, rootUrl: string, params?: CreateMehrarbeitAuszahlung$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MehrarbeitAuszahlungDto>> {
  const rb = new RequestBuilder(rootUrl, createMehrarbeitAuszahlung$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MehrarbeitAuszahlungDto>;
    })
  );
}

createMehrarbeitAuszahlung$Plain.PATH = '/v1/mehrarbeitauszahlung/create';
